<template>
  <Walkthrough 
    roomName="Celda de la Cárcel"
    roomKey="jailcell"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="spanish"
  />
</template>
<script>

export default {
  name: 'Celda',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/jailcell-1920x1280.jpg",
      steps: [
        "Mira hacia abajo e inspecciona el piso. Debes encontrar una llave inglesa debajo de un ladrillo suelto.",
        "Mira a la derecha e inspecciona el espejo. Debes encontrar una vieja lima de uñas escondida allí.",
        "Mirar hacia adelante e inspeccionar la cama. Encontrarás un traje de prisión debajo de ella.",
        "Ahora usa la lima de uñas en la cama. Raspa un poco de pintura y encuentra dibujos de un espejo, un fregadero, una puerta y un orificio de ventilación debajo.",
        "Todavía mirando hacia adelante, inspeccionar la almohada, debes encontrar una hojilla. Esta será útil más tarde. Asegúrate de no olvidar recogerla. ;),",
        "Las imágenes en la cama eran en realidad pistas. Usando la dirección en la que se encuentran esos elementos en la celda, ahora sabes cómo girar la llave inglesa. Mira a la derecha y luego usa la llave inglesa en el tubo. Gírala a la derecha, a la derecha, a la izquierda, luego hacia arriba. Esto debería devolver el flujo de agua de regreso en la celda.",
        "Con el agua fluyendo, mira hacia adelante otra vez y usa el traje de la prisión en el inodoro para tirarlo allí.",
        "Con el traje de la prisión atascado en el inodoro, úsalo nuevamente. El agua comenzará a desbordarse y al aumento del nivel del agua te llevará a la rendija de ventilación donde usarás la cuchilla para abrirla y liberarte. Felicitaciones has escapado. ¡Intenta resolver la siguiente habitación por tu cuenta!",
        ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/es/jailcell.vue